module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-300644d8!./packages/dof-noticebar/colmo.css
// module id = 459
// module chunks = 0 1